import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {REPORT_TYPES} from 'helpers/constants/reports';
import {
  TopCustomersSection,
  TopCustomersHeader,
  SectionTitle,
  ViewAllLink
} from '../styles';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    text-align: left;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 100%;
    color: #172751;
    padding: 18px 18px 18px 0;
    border-bottom: 1px solid #929cb9;
  }

  td {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
    color: #172751;
    padding: 18px 18px 18px 0;
    border-bottom: 1px solid #929cb9;
  }

  td.name,
  td.spent {
    font-weight: 700;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

const EmptyMessage = styled.div`
  padding: 32px;
  text-align: center;
  color: #6b7280;
`;

const formatCurrency = (v) =>
  v == null
    ? '—'
    : `$${Number(v).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;

const TopCustomersTable = ({customers}) => {
  const history = useHistory();

  const rows = customers || [];

  return (
    <TopCustomersSection>
      <TopCustomersHeader>
        <SectionTitle>Top Customers</SectionTitle>
        <ViewAllLink
          type='button'
          onClick={() =>
            history.push({
              pathname: '/reports',
              search: `?type=${REPORT_TYPES.CUSTOMERS_SUMMARY}`
            })
          }
        >
          View All
        </ViewAllLink>
      </TopCustomersHeader>
      {rows.length === 0 ? (
        <EmptyMessage>No customers to show.</EmptyMessage>
      ) : (
        <Table>
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Total Orders</th>
              <th>Total Spent</th>
              <th>Zip Code</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.customerKey}>
                <td className='name'>{c.customerName}</td>
                <td>{c.orderCount}</td>
                <td className='spent'>{formatCurrency(c.totalSpent)}</td>
                <td>{c.primaryCustomerLocation?.postalCode || '—'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </TopCustomersSection>
  );
};

TopCustomersTable.propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      customerKey: PropTypes.string,
      customerName: PropTypes.string,
      customerPhone: PropTypes.string,
      orderCount: PropTypes.number,
      totalSpent: PropTypes.number,
      primaryCustomerLocation: PropTypes.shape({
        postalCode: PropTypes.string,
        city: PropTypes.string,
        stateCode: PropTypes.string,
        countryCode: PropTypes.string
      })
    })
  )
};

TopCustomersTable.defaultProps = {
  customers: []
};

export default TopCustomersTable;
